import React, {ReactElement, ReactNode} from 'react';
import {FormattedMessage} from 'react-intl';
import {useLocale} from '../../../../RootProvider/LocaleContext';
import {getPageRoute} from '../../../../utils/routes/getPageRoute';
import Button, {ButtonVariant} from '../Button/Button';

export interface GetStartedButtonProps {
  buttonText?: ReactNode;
  url?: string;
}

function GetStarted({buttonText, url}: GetStartedButtonProps): ReactElement {
  const locale = useLocale();
  const getStartedButtonText = buttonText || <FormattedMessage id="apply.cta.getStarted" />;
  const getStartedButtonUrl = url || getPageRoute('quoteForm', locale);

  return (
    <Button
      href={getStartedButtonUrl}
      variant={ButtonVariant.CALL_TO_ACTION}
      ariaLabel={`${getStartedButtonText}`}
      testId="button.getStarted"
    >
      {getStartedButtonText}
    </Button>
  );
}

export default GetStarted;
